import React, { Component } from 'react'
import { connect } from 'react-redux'
import HeaderCP from './HeaderCP'
import OverviewCP from '../overview/OverviewCP'
import GameFrameCP from '../game/GameFrameCP'
import RulesFrameCP from '../game/RulesFrameCP'
import AdminCP from '../admin/AdminCP'
import SystemMessageCP from './SystemMessageCP'
import UIActions from '../../actions/ui/ui-actions'


class SiteFrameCP extends Component {
  constructor() {
    super()
    // this.state = {}
  }

  render() {
    let activePanel = []

    if (UIActions.enums.pageNames.GAME === this.props.activePageName) {
      activePanel = (<GameFrameCP />)
    } else if (UIActions.enums.pageNames.RULES === this.props.activePageName) {
      activePanel = (<RulesFrameCP />)
    } else if (
      UIActions.enums.pageNames.ADMIN === this.props.activePageName
      && this.props.user?.auth > 0
    ) {
      activePanel = (<AdminCP />)
    } else {
      activePanel = (<OverviewCP />)
    } 

    return (
      <div className='main-contain'>
        <HeaderCP />
        <div className='main-section'>
          {activePanel}
        </div>
        <SystemMessageCP />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    activePageName: state.ui.activePageName,
    user: state.user.user,
  }
}
  
const mapDispatchToProps = (dispatch) => {
  return {}
}
  
export default connect(mapStateToProps, mapDispatchToProps)(SiteFrameCP)